import instObj from '@/backend/axios-instances'

const resource = "/project/"
const instance = instObj.baseInstance

export default {
  get(id, parameters) {
    return instance.get(`${resource}${id}`, { params: parameters })
  }
}
